import { UI_SET_LOADER, UI_SET_LOADER_TEXT, SET_UI_PROPERTY } from 'store/actions/ui';

export default {
  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [SET_UI_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_UI_PROPERTY, {
      field,
      value
    })
};
